import { render, staticRenderFns } from "./DriverInformations.vue?vue&type=template&id=6b7d4658&scoped=true"
import script from "./DriverInformations.vue?vue&type=script&lang=js"
export * from "./DriverInformations.vue?vue&type=script&lang=js"
import style0 from "./DriverInformations.vue?vue&type=style&index=0&id=6b7d4658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d4658",
  null
  
)

export default component.exports